module.exports = __webpack_public_path__ + "img/relink-main-logo-black.847a058.png";